import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Input from '../input';
import MsxIcons from '../../features/msx-icons';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../color-constants';

const CustomInput = styled(Input)`
  width: calc(100% - 10px);
  padding: 5px;
  margin-right: 5px;
`;

const Container = styled.div`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  ${({ hasError }) => {
    return hasError ? `
    ${CustomInput} {
      border: 1px solid red;
    }
    `: '';
  }}
`;

const EditHint = styled.span`
  display: inline-block;
  margin-left: 5px;
  ${props => props.color === 'primary' ? `
    color: ${SECONDARY_COLOR};
    color: var(--se-primary, ${SECONDARY_COLOR});
  ` : (props.color === 'white' ? `color: white;` : `
    color: ${PRIMARY_COLOR};
    color: var(--se-secondary, ${PRIMARY_COLOR});
  `)}
`;

const Icon = styled.span`
  display: inline-block;
  text-decoration: none !important;
  cursor: pointer;
`;
const DoneIcon = styled(Icon)`
`;
const CancelIcon = styled(Icon)`
  color: ${props => props.color};
`;

class DynamicInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.initialValue,
      hasError: false,
    };
  }

  static propTypes = {
    initialValue: PropTypes.string,
    setValue: PropTypes.func,
    withCancel: PropTypes.bool,
    cancel: PropTypes.func,
    customInputProps: PropTypes.object,
  }

  handleInputValueChange = (event) => {
    const { value } = event.target;
    if (this.state.value !== value) {
      this.setState({ value, hasError: false });
    } else {
      return false;
    }
  }

  validateValue(value) {
    const validateValueFunc = this.props.validateValue ? this.props.validateValue : v => true;
    return validateValueFunc(value);
  }

  render = () => {
    const doneColorProps = {
      color: (this.props.customInputProps?.color) || 'secondary'
    };
    const cancelColorProps = {
      color: (this.props.customInputProps?.color) || '#d1d1d1'
    };

    return (
      <Container hasError={this.state.hasError}>
        <CustomInput
          type="text"
          name="customInput"
          required
          value={this.state.value}
          onChange={this.handleInputValueChange}
          autoComplete="off"
          onKeyPress={(event) => {
            // 13 corresponds to the "Enter" key.
            if (event.key === 'Enter') {
              event.preventDefault();
              event.stopPropagation();
              const value = this.state.value;
              if (!this.validateValue(value)) {
                this.setState({ hasError: true });
              } else {
                this.props.setValue(value);
              }
            }
          }}
          {...this.props.customInputProps}
        ></CustomInput>
        {this.props.editHintText && <EditHint {...doneColorProps}>{this.props.editHintText}</EditHint>}
        <DoneIcon onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const value = this.state.value;
          if (!this.validateValue(value)) {
            this.setState({ hasError: true });
          } else {
            this.props.setValue(value);
          }
        }}>
          <MsxIcons name="done" size="medium" {...doneColorProps}></MsxIcons>
        </DoneIcon>
        {this.props.withCancel &&
          <CancelIcon onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.cancel();
          }}>
            <MsxIcons name="close" size="nano" {...cancelColorProps}></MsxIcons>
          </CancelIcon>
        }
      </Container>
    );
  }
}

export default DynamicInput;
